import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import PackageIncludes from './components/PackageIncludes';
import Contact from './components/Contact';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://charliepaidsocial.com';

const SCHEMA_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Person",
      "@id": `${SITE_URL}/#person`,
      "name": "Charlie Peters",
      "jobTitle": "Meta Ads Specialist",
      "url": SITE_URL,
      "email": "charliegeorgep97@gmail.com",
      "telephone": "+447946707154",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "GB"
      },
      "sameAs": [
        "https://www.linkedin.com/in/charliegeorgepeters/"
      ]
    },
    {
      "@type": "ProfessionalService",
      "@id": `${SITE_URL}/#service`,
      "name": "Charlie Peters – Meta Ads Specialist",
      "description": "Expert Facebook & Instagram ad campaign management for UK businesses. Certified Meta Paid Specialist offering full-service Meta Ads management, strategy, and optimisation.",
      "url": SITE_URL,
      "telephone": "+447946707154",
      "email": "charliegeorgep97@gmail.com",
      "areaServed": { "@type": "Country", "name": "United Kingdom" },
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "GB"
      },
      "priceRange": "££",
      "serviceType": [
        "Facebook Ads Management",
        "Instagram Ads Management",
        "Meta Ads Strategy",
        "Paid Social Media Advertising",
        "Meta Pixel Setup",
        "Campaign Optimisation"
      ],
      "provider": { "@id": `${SITE_URL}/#person` }
    },
    {
      "@type": "FAQPage",
      "@id": `${SITE_URL}/#faq`,
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What does Meta Ads management include?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The service includes a full consultation and strategy session, complete ad account set-up, Meta Pixel installation, ongoing monitoring and optimisation, and clear monthly reporting with actionable recommendations."
          }
        },
        {
          "@type": "Question",
          "name": "How much does Meta Ads management cost?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Pricing is based on your monthly ad spend with tiered pricing to suit businesses of all sizes. Flexible rolling monthly contracts are available, as well as one-off campaign options for product launches or seasonal pushes."
          }
        },
        {
          "@type": "Question",
          "name": "Do you offer one-off Meta ad campaigns?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes — one-off campaigns are available for product launches, seasonal pushes, or short-term projects. If you're not ready for ongoing management, a one-off campaign is a great starting point."
          }
        },
        {
          "@type": "Question",
          "name": "Who do you work with?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Services are available remotely to any business looking to grow through Facebook and Instagram advertising. Whether you're a small business or a scaling brand, get in touch to see how Meta Ads can work for you."
          }
        }
      ]
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      "url": SITE_URL,
      "name": "Charlie Peters – Meta Ads Specialist",
      "description": "Facebook & Instagram Ads Specialist | Meta Ads Management | UK",
      "inLanguage": "en-GB"
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      "url": SITE_URL,
      "name": "Meta Ads Specialist | Facebook & Instagram Ads Management UK",
      "description": "Certified Meta Ads specialist Charlie Peters. Expert Facebook & Instagram ad campaign management for UK businesses. Targeted paid social that converts.",
      "isPartOf": { "@id": `${SITE_URL}/#website` },
      "about": { "@id": `${SITE_URL}/#person` },
      "inLanguage": "en-GB",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": SITE_URL
          }
        ]
      }
    }
  ]
};

export default function Home() {
  useEffect(() => {
    const existing = document.getElementById('schema-home');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(SCHEMA_LD);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <AboutMe />
      <PackageIncludes />
      <Contact />
      <Footer />
    </div>
  );
}
